/* eslint-disable max-classes-per-file */
import { Directive, inject, Input, OnDestroy, Optional, SkipSelf } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ApBaseClass } from 'webcommon/shared';

// these directives are used to add id's to elements, where it can append the prefix and suffix together
// without having to pass them around everywhere

@Directive({
  selector: '[apBaseId]',
  standalone: true,
  host: {
    '[id]': 'prefix',
  },
})
export class BaseIdDirective implements OnDestroy {
  @Input('apBaseId')
  get prefix() {
    return this._prefix;
  }
  set prefix(value) {
    if (this._prefix !== value) {
      this._prefix = value;
      this.prefixChange$.next(value);
    }
  }
  private _prefix = '';

  readonly prefixChange$ = new ReplaySubject<string>(1);

  static setupAsHostDirective(prefixFn: () => string) {
    const baseIdDirective = inject(BaseIdDirective, {
      self: true,
    });
    baseIdDirective.prefix = prefixFn();
  }

  ngOnDestroy() {
    this.prefixChange$.complete();
  }
}

@Directive({
  selector: '[apChildId]',
  standalone: true,
  host: {
    '[id]': 'basePrefix + suffix',
  },
})
export class ChildIdDirective extends ApBaseClass {
  @Input('apChildId') suffix: string;
  basePrefix = '';

  constructor(
    @SkipSelf() @Optional() private baseIdDirective: BaseIdDirective | null,
  ) {
    super();
    this.baseIdDirective?.prefixChange$.pipe(
      tap((prefix) => {
        this.basePrefix = prefix + '-';
      }),
      this.takeUntilDestroy(),
    ).subscribe();
  }
}
